export default class CSSClassSerivce {

  //basic
  private static baseInputClass: string = "text-base w-full flex hover:text-bluec block px-3.5 py-2.5 border-white text-gray-900 rounded-md dark:bg-gray-200 cursor-pointer";

  //label
  public static labelClass: string = "text-xs font-medium flex flex-row";

  //text
  public static textInputClass: string = this.baseInputClass;

  public static textAreaRootClass: string = "flex flex-col w-full h-full pb-1";
  public static textAreaInputClass: string = this.baseInputClass + "flex flex-row h-full resize-none";
  public static textAreaReziseAbleInputClass: string = this.baseInputClass + "flex flex-row h-[10rem]";
  
  
  public static textReadClass: string = this.baseInputClass + " [&&]:px-0 [&&]:border border-none";
  public static textReadClass1: string = this.baseInputClass + " px-2";

  //select
  public static selectClass = this.baseInputClass + "";
  public static selectClass1 = this.baseInputClass + "mt-2 px-0 py-0";

  //checkBox
  public static checkBoxGroup = "border border-gray-400";
  public static checkBoxClassFrame = this.baseInputClass + " [&&]:border-none flex flex-row";
  public static checkBoxClassFrame1 = this.baseInputClass;

  public static checkBoxFrame: string = this.baseInputClass;
  public static checkBoxClass: string = "h-6 w-6 ml-0 rounded-md cursor-pointer";

  //radio
  public static radioClassRootFrame = "mt-2";
  public static radioClassBaseFrameCol: string = this.baseInputClass + "flex flex-col [&&]:border-none";
  public static radioClassBaseFrameRow: string = this.baseInputClass + " flex flex-row [&&]:border-none";
  public static radioClassFrame: string = "flex flex-row ml-1 mt-0 rounded-lg pt-1.5 pl-2 [&&]:min-w-40 bg-gray-30";
  public static radioClassInput: string = "m-2 ml-0 mr-0 mt-1 p-0"

  //datePicker
  public static datePickerFrame = "w-full";
  public static datePickerInput = this.baseInputClass;
  public static datePickerListItem = "border border-none bg-transparent [&&]:pl-0 cursor-pointer pt-0";


  //listitem
  public static itemList = "flex flex-row w-full p-0 mb-2 rounded-lg border border-grey-200 shadow-lm hover:bg-gray-300 cursor-pointer"
  public static listItem = "w-full flex p-0 mb-0"
  public static listItemItem = "w-32 pl-0 ml-0 p-1 overflow-hidden";
  public static listItemItemWide = "w-52 p-1";
  public static listItemItemWide1 = "w-1/4 p-1";


  //common
  //public static disabledAddClass: string = "[&&]:bg-gray-100 [&&]:bg-opacity-75 [&&]:cursor-not-allowed";
  public static disabledAddClass: string = "[&&]:bg-opacity-50 [&&]:border-gray-100 [&&]:cursor-not-allowed";
  
  //button
  //"text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800
  public static buttonCancelClass: string = "px-2 py-2 mx-4 font-medium bg-blue-500 hover:bg-blue-800 active:bg-green-800 rounded-md text-white";
  public static buttonSubmit: string = "px-2 py-2 mx-2 font-medium border border-transparent rounded-md shadow-sm text-sm text-white bg-gray-600 hover:bg-gray-700";

  public static buttonwhite: string = "px-2 py-1 font-medium border border-transparent rounded-md shadow-sm text-sm text-white bg-white hover:bg-gray-300";
  public static buttonwhiteInactive: string = "px-2 py-1 mx-2 font-medium border border-transparent rounded-md shadow-sm text-sm text-white bg-white bg-opacity-25 cursor-default";
  
  //button unassigned
  public static buttonSignIn = "w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-violet-800 hover:bg-violet-700";
  public static buttonSquareAbsolute: string = "border border-gray-400 rounded-md absolute";
  
  public static buttonSquareNoAction: string = "rounded-md p-1 cursor-default";
  public static buttonSquare: string = this.buttonSquareNoAction + " [&&]:cursor-pointer border border-gray-400  hover:bg-gray-300";

  public static buttonSquareNoBorder: string = this.buttonSquare + " [&&]:border-none hover:bg-gray-300";
  public static button0: string = "flex justify-center py-2 px-4 mx-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-violet-700";
  public static button1: string = "text-sm text-violet-600 hover:text-violet-500"; 
  public static button2: string = "hover:bg-gray-200 mt-1 block w-full px-4 py-2 border border-gray-300 bg-gray-0 dark:bg-gray-500 dark:text-gray-900 rounded-md ";
}